import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 5AAB267C-9A9C-4966-862D-A2AC910494E5
 * name message-bulleted-off
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-bulleted-off.svg
 * tags
 */
export const MessageBulletedOffIcon = createSvgIcon(<><path d="M1.27,1.73L0,3L2,5V22L6,18H15L20.73,23.73L22,22.46L1.27,1.73M8,14H6V12H8V14M6,11V9L8,11H6M20,2H4.08L10,7.92V6H18V8H10.08L11.08,9H18V11H13.08L20.07,18C21.14,17.95 22,17.08 22,16V4A2,2 0 0,0 20,2Z" /></>, 'MessageBulletedOffIcon');
export default MessageBulletedOffIcon